<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col>
          <v-select
            v-model="id_donation_groups"
            :options="donationGroups"
            label="title"
            :reduce="item => item.id"
            placeholder="Ana Grup Filtresi"
            @input="getDataList"
          />
        </b-col>
        <b-col
          cols="12"
          md="auto"
        >
          <b-button
            variant="primary"
            :to="$route.path + '/add'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      fixed
    >
      <template #cell(title)="data">
        <div :class="!data.item.id_donation_groups? 'text-primary font-weight-bold' : ''">
          {{ data.item.title }}
        </div>
        <div
          v-if="data.item.id_donation_types"
          class="font-small-2 d-flex justify-content-between align-items-center"
          :class="data.item.id_donation_types === '1'? 'text-danger' : 'text-success'"
        >
          <div>
            {{ data.item.donation_type }}
          </div>
          <b-badge
            v-if="data.item.id_account_types"
            :variant="data.item.id_account_types === '1'? 'light-success' : 'light-danger'"
          >
            {{ data.item.account_type }}
          </b-badge>
        </div>
      </template>
      <template #cell(main_group)="data">
        <div
          v-if="data.item.main_group"
          class="text-muted"
        >
          {{ data.item.main_group }}
        </div>
        <div
          v-else
          class="text-primary font-weight-bold"
        >
          Ana Grup
        </div>
      </template>
      <template #cell(control)="data">
        <div
          v-if="data.item.is_locked"
          class="text-right"
        >
          <FeatherIcon
            icon="LockIcon"
          />
        </div>
        <div
          v-else
          class="text-right"
        >
          <list-buttons

            primary-text="Güncelle"
            :primary-action="$route.path + '/edit/' + data.item.id"
            :delete-action="removeData"
            :data-id="data.item.id"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTable,
  BPagination,
  BButton,
  BCardFooter,
  BBadge,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListDropdownButtons.vue'
import toastMixin from '@/libs/toast'
import vSelect from 'vue-select'

const tableName = 'donation_groups'
export default {
  name: 'Index',
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    BBadge,
    ListButtons,
    vSelect,
  },
  mixins: [toastMixin],
  data() {
    return {
      id_donation_groups: null,
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'BAŞLIK',
        },
        {
          key: 'main_group',
          label: 'ÜST GRUP',
          thClass: 'width-300 text-nowrap',
          tdClass: 'width-300 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-200',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          'main_group.title AS main_group',
          'donation_types.title AS donation_type',
          'account_types.title AS account_type',
          `${tableName}.is_locked AS is_locked`,
          `${tableName}.id_donation_types AS id_donation_types`,
          `${tableName}.id_donation_groups AS id_donation_groups`,
          `${tableName}.id_account_types AS id_account_types`,
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    donationGroups() {
      return this.$store.getters['donationGroups/mainDataList']
    },
    dataList() {
      return this.$store.getters['donationGroups/dataList']
    },
    dataCounts() {
      return this.$store.getters['donationGroups/dataCounts']
    },
    saveData() {
      return this.$store.getters['donationGroups/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({ template: 'removeSuccess' })
      } else if (val.status === false) {
        this.showToast({ template: 'removeError' })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDonationGroups()
    this.getDataList()
  },
  methods: {
    getDonationGroups() {
      this.$store.dispatch('donationGroups/getMainList', {
        select: [
          'donation_groups.id AS id',
          'donation_groups.title AS title',
        ],
        where: {
          'donation_groups.id_donation_groups': null,
          'donation_groups.is_expense': 1,
        },
      })
    },
    getDataList() {
      if (this.id_donation_groups) {
        this.dataQuery.where = {
          'donation_groups.id_donation_groups': this.id_donation_groups,
          'donation_groups.is_expense': 1,
        }
      } else {
        this.dataQuery.where = {
          'donation_groups.is_expense': 1,
        }
      }
      this.$store.dispatch('donationGroups/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('donationGroups/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
}
</script>
